import { MethodPropertyModifySettingsForm } from "components/Forms/MethodPropertyModifySettingForm/MethodPropertyModifySettingsForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface ResponseHowToUseSettingDrawerProps {
    name: number; // index of the condition in the responseConnectionPropertiesCheck array
    methodIndex: number; // index of the method in methods array
    responseHandlerIndex: number; // index of the response handler in responseHandlers array
}

export const ResponseHowToUseSettingDrawer: FC<ResponseHowToUseSettingDrawerProps> = ({
    name,
    methodIndex,
    responseHandlerIndex,
}) => {
    const { t } = usePaldockTranslation("drawers.response-how-to-use-setting");
    const drawerId = DrawerId.ResponseHowToUseSetting;

    const propertyPath =
        `methods.${methodIndex}.requestConfig.responseHandlers.${responseHandlerIndex}.responseConnectionProperties.${name}` as const;

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title", { name })} />}
            searchParamsToClean={[`${drawerId}-id`, `${drawerId}-methodIndex`, `${drawerId}-responseHandlerIndex`]}
        >
            <MethodPropertyModifySettingsForm propertyPath={propertyPath} />
        </Drawer>
    );
};
